import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {AppRoutingModule} from '@app/app-routing.module';
import {BrowserModule} from '@angular/platform-browser';
import {DeletedScreenComponent} from './components/deleted-screen/deleted-screen.component';
import {HttpClientModule} from '@angular/common/http';
import {TitleCasePipe} from '@angular/common';
import {UserPermissionsService} from '@core/user-permissions';
import {AppGlobalErrorHandler} from '@app/services/error-handler.service';
import {WINDOW_PROVIDERS} from '@app/services/window.service';
import {AppLoaderComponent} from '@app/components/app-loader/app-loader.component';
import {PageErrorComponent} from '@app/pages/page-error/page-error.component';
import {LoadingInterceptor} from '@app/services/loading.interceptor';


function initializeApp(
	userPermissionsService: UserPermissionsService
) {
	return () => new Promise(resolve => {
		// get-user-permissions API call sets cookie for anonymous users. It should be the first call.
		userPermissionsService
			.getCurrentValue()
			.toPromise()
			.then(() => {
				resolve(null);
			})
			.catch(() => {
				resolve(null);
			});
	});
}

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		AppRoutingModule,
		BrowserModule,
		HttpClientModule,
		AppLoaderComponent,
		DeletedScreenComponent,
		PageErrorComponent
	],
	providers: [
		WINDOW_PROVIDERS,
		TitleCasePipe, // TODO: service-level provider (-15.8 khz)
		{
			deps: [UserPermissionsService],
			multi: true,
			provide: APP_INITIALIZER,
			useClass: LoadingInterceptor,
			useFactory: initializeApp
		},
		{
			provide: ErrorHandler,
			useClass: AppGlobalErrorHandler
		},
	],
	exports: [],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {
}
